import { __makeTemplateObject } from "tslib";
import { css, RcClasses, } from '../../../../foundation';
import { RcIconButton } from '../../../Buttons/IconButton';
export var RcTextFieldClasses = RcClasses(['root'], 'RcTextField');
export var RcTextFieldInputClasses = RcClasses(['root', 'underline', 'error', 'focused', 'disabled', 'input'], 'RcTextFieldInput');
export var RcTextFieldInputLabelClasses = RcClasses(['root', 'error', 'focused', 'disabled'], 'RcTextFieldInputLabel');
export var RcTextFieldFormHelperTextClasses = RcClasses(['root', 'error', 'disabled'], 'RcTextFieldFormHelperText');
export var belowIconButtonSpacing = function (spaceNum) {
    var themeFn = function (_a) {
        var clearBtn = _a.clearBtn;
        if (clearBtn) {
            return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        *:not(input) + ", " {\n          margin-left: ", ";\n        }\n      "], ["\n        *:not(input) + ", " {\n          margin-left: ", ";\n        }\n      "])), RcIconButton, spaceNum);
        }
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", " {\n        margin-left: ", ";\n      }\n    "], ["\n      ", " {\n        margin-left: ", ";\n      }\n    "])), RcIconButton, spaceNum);
    };
    return themeFn;
};
var templateObject_1, templateObject_2;
